import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import "@ui5/webcomponents/dist/BusyIndicator.js";
import "@ui5/webcomponents-icons/dist/locked.js";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "2rem",
          }}
        >
          <ui5-busy-indicator
            active
            size="Large"
            style={{ marginBottom: "1rem" }}
          ></ui5-busy-indicator>
          <div
            style={{
              color: "#6c757d",
              fontSize: "1rem",
            }}
          >
            Loading...
          </div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f8f9fa",
          padding: "2rem",
        }}
      >
        <div
          style={{
            textAlign: "center",
            maxWidth: "400px",
            padding: "2rem",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div
            style={{
              backgroundColor: "#dc3545",
              borderRadius: "50%",
              width: "64px",
              height: "64px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1rem auto",
            }}
          >
            <ui5-icon
              name="locked"
              style={{
                fontSize: "1.5rem",
                color: "white",
              }}
            ></ui5-icon>
          </div>
          <h2
            style={{
              color: "#dc3545",
              marginBottom: "1rem",
              fontSize: "1.5rem",
              fontWeight: "600",
            }}
          >
            Access Denied
          </h2>
          <p
            style={{
              color: "#6c757d",
              marginBottom: "1.5rem",
              lineHeight: "1.5",
            }}
          >
            You don't have permission to access this page. Administrator
            privileges are required.
          </p>
          <button
            onClick={() => window.history.back()}
            style={{
              backgroundColor: "#0854a0",
              color: "white",
              border: "none",
              padding: "0.75rem 1.5rem",
              borderRadius: "6px",
              fontSize: "0.875rem",
              fontWeight: "500",
              cursor: "pointer",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#073d82";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#0854a0";
            }}
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  // Render children if authenticated (and admin if required)
  return children;
};

export default ProtectedRoute;
